var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-button",class:{ 'switch-on': _vm.click },on:{"click":_vm.toggle}},[_c('div',{staticClass:"switch-handle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }